import React from 'react'
import { SessionService } from '../../services/SessionService'
import BrokerConfigService from '../../services/BrokerConfigService'
import { TextField, InputAdornment } from '@material-ui/core'
import { BrokerIdentityCodePopover } from './Popover/BrokerIdentityCodePopover'

export const BrokerIdentityCode = ({ className, name, register, helperText, error }) => {
  const [codeTooltip, setCodeTooltip] = React.useState('')
  const [codePlaceholder, setCodePlaceholder] = React.useState('Code')
  const [codeRegex, setCodeRegex] = React.useState('.*')

  React.useEffect(() => {
    if (SessionService.isAgencyRequiresIdentityCode()) {
      BrokerConfigService.getValue('code_tooltip').then(value => setCodeTooltip(value))
      BrokerConfigService.getValue('code_placeholder').then(value => setCodePlaceholder(value))
      BrokerConfigService.getValue('code_regex').then(value => setCodeRegex(value))
    }
  }, [])

  return (
    <TextField
      InputLabelProps={{ className: 'avenir-book' }}
      variant="outlined"
      label={codePlaceholder}
      className={className}
      name={name}
      inputRef={register({
        required: true,
        pattern: { value: new RegExp(codeRegex), message: 'Invalid code' },
        maxLength: { value: 7, message: 'Invalid code' },
      })}
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment>
            {' '}
            <BrokerIdentityCodePopover text={codeTooltip} />{' '}
          </InputAdornment>
        ),
      }}
      error={error}
    />
  )
}
